'use client'
import type { Bookmark, User } from '@/lib/db/schema'
import { SourceLanguageCode, TargetLanguageCode, TextResult } from 'deepl-node'
import { Dispatch, SetStateAction, createContext } from 'react'
import { TargetLanguage } from '../types'
import { SearchParamsEndoced } from './get-search-params'

export type UserContextProps = {
    commitHash?: string
    saveLanguageOrder: (
        targetLanguageCode: TargetLanguageCode,
        visibleParent: TargetLanguageCode,
        up: boolean
    ) => Promise<void>
    lastSavedUrl: string
    setLastSavedUrl: Dispatch<SetStateAction<string>>
    langOrder: TargetLanguage[]
    bookmarks: Bookmark[]
    setBookmarks?: Dispatch<SetStateAction<Bookmark[]>>
    deleteBookmark: (userId: number, id: number) => void
    saveBookmark: (userId: number, label: string, labelLang: string, params: SearchParamsEndoced) => Promise<number>
    fetchTranslation: (
        term: string,
        sourceLang: SourceLanguageCode,
        targetLang: TargetLanguageCode
    ) => Promise<
        | TextResult
        | {
              status: number
              body: string
          }
    >
}

export const UserContext = createContext({} as UserContextProps)

export type CurrentContextProps = {
    user: User
}
export const CurrentUserContext = createContext({
    user: {} as User,
})
